<!--
 * @Description:
 * @Version: 2.0
 * @Autor: sen.yang
 * @Date: 2022-01-06 19:54:47
 * @LastEditors: sen.yang
 * @LastEditTime: 2022-05-12 09:15:53
-->
<template>
  <div class="download-row">
    <div class="bg"></div>
    <div class="logo"></div>
    <div class="title">长颈鹿医加</div>
    <div class="label">医生端</div>
    <div class="button-card" @click="downLoad">立即下载</div>
    <div class="button-label">
      已经安装？
      <span style="color:#2267F2" @click="submit">戳这里</span>
    </div>
  </div>
</template>

<script>
export default {
  metaInfo: {
    title: "长颈鹿医加"
  },
  data() {
    return {
    };
  },
  computed:{
    open(){
      return this.$route.query.open
    }
  },
  methods: {
    submit() {
      if(this.open){
         this.$copy(`open=${this.open}`)
      }
      if (this.$common.phoneType().isiOS) {
        window.location.href = "medi://com.medi.yj";
        setTimeout(function() {
          window.location.href = "https://apps.apple.com/cn/app/id1484041430";
          window.location.href = "https://apps.apple.com/cn/app/id1484041430"; //两遍
        }, 2000);
      }
      if (this.$common.phoneType().isAndroid) {
        window.location.href = "medi://com.medi.yj"+`/open=${this.open}`;

        setTimeout(function() {
          window.location.href =
            "https://3g.lenovomm.com/redsea/com.mediwelcome.hospital?rank_code=search_2_%E9%BA%A6%E8%BF%AA%E5%8C%BB%E5%8A%A0&num=1";
        }, 2000);
      }
    },
    downLoad() {
      if (this.$common.phoneType().isiOS) {
        window.location.href = "https://apps.apple.com/cn/app/id1484041430";
      }
      if (this.$common.phoneType().isAndroid) {
        window.location.href =
          "https://3g.lenovomm.com/redsea/com.mediwelcome.hospital?rank_code=search_2_%E9%BA%A6%E8%BF%AA%E5%8C%BB%E5%8A%A0&num=1";
      }
    }
  }
};
</script>

<style scoped>
.download-row {
  min-height: 99vh;
  display: inline-block;
  width: 100vw;
  overflow: auto;
}
.download-row::before {
  content: "";
  background: linear-gradient(180deg, #d9e8ff 0%, rgba(255, 255, 255, 0) 100%);
  height: 48vw;
  width: 100vw;
  position: absolute;
  top: 0;
  left: 0;
}
.logo {
  background-image: url("../../assets/new_logo.png");
  background-size: 26.6vw;
  background-repeat: no-repeat;
  width: 26.6vw;
  height: 26.6vw;
  margin: 28.1vw auto 6.6vw auto;
  position: relative;
}
.title {
  font-size: 6.9vw;
  color: #12141a;
  text-align: center;
  margin-bottom: 2.6vw;
}
.label {
  color: #9ea2a8;
  font-size: 4.2vw;
  text-align: center;
}
.button-card {
  color: #ffffff;
  text-align: center;
  width: 84vw;
  margin: 46vw auto 5.3vw auto;
  font-size: 4.8vw;
  background-color: #2267f2;
  border-radius: 2.1vw;
  height: 14.1vw;
  line-height: 14.1vw;
}
.button-label {
  font-size: 4.2vw;
  color: #9ea2a8;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/views/agreement/download.vue